export const LIMIT_TYPES = {
	DEPOSIT: "deposit",
	LOSS: "loss",
	BET_COUNT: "betCount",
	SESSION_TIME: "sessionTime",
};

export const LIMIT_TYPE_ORDER = [
	LIMIT_TYPES.DEPOSIT,
	LIMIT_TYPES.LOSS,
	LIMIT_TYPES.BET_COUNT,
	LIMIT_TYPES.SESSION_TIME,
];

export const LIMIT_PERIODS = {
	ROLLING_24H: "rolling_24h",
	ROLLING_7D: "rolling_7d",
	ROLLING_30D: "rolling_30d",
};

export const LIMIT_PERIOD_ORDER = [
	LIMIT_PERIODS.ROLLING_24H,
	LIMIT_PERIODS.ROLLING_7D,
	LIMIT_PERIODS.ROLLING_30D,
];

export const RG_ERROR_CODES = {
	INVALID_PARAM: "InvalidParam",
	INVALID_LIMIT_TYPE: "InvalidLimitType",
	INVALID_PERIOD: "InvalidPeriod",
	EXCEEDS_BACKOFFICE_LIMIT: "ExceedsBackofficeLimit",
	PENDING_LIMIT_CHANGE: "PendingLimitChange",
	DEPOSIT_LIMIT_EXCEEDED: "DEPOSIT_LIMIT_EXCEEDED",
	SESSION_TIME_LIMIT_EXCEEDED: "SESSION_TIME_LIMIT_EXCEEDED",
	LOSS_LIMIT_EXCEEDED: "LOSS_LIMIT_EXCEEDED",
	BET_COUNT_LIMIT_EXCEEDED: "BET_COUNT_LIMIT_EXCEEDED",
};

export const SESSION_TIME_MIN_SECONDS = 60;

export const LIMIT_TYPE_I18N_KEYS = {
	[LIMIT_TYPES.DEPOSIT]: "limits.types.deposit",
	[LIMIT_TYPES.LOSS]: "limits.types.loss",
	[LIMIT_TYPES.BET_COUNT]: "limits.types.betCount",
	[LIMIT_TYPES.SESSION_TIME]: "limits.types.sessionTime",
};

export const LIMIT_PERIOD_I18N_KEYS = {
	[LIMIT_PERIODS.ROLLING_24H]: "limits.periods.rolling24h",
	[LIMIT_PERIODS.ROLLING_7D]: "limits.periods.rolling7d",
	[LIMIT_PERIODS.ROLLING_30D]: "limits.periods.rolling30d",
};

export const isProfileLimitsModuleEnabled = () =>
	Array.isArray(window.PROFILE_LIMITS_MODULE) && window.PROFILE_LIMITS_MODULE.length > 0;

export const getEnabledLimitTypes = () => {
	if (!isProfileLimitsModuleEnabled()) {
		return [];
	}

	return LIMIT_TYPE_ORDER.filter((type) => window.PROFILE_LIMITS_MODULE.includes(type));
};
